import { createFileRoute } from '@tanstack/react-router';
import PageWrapper from 'src/components/PageWrapper/PageWrapper';
import UnauthorizedError from '../../../../api/error/UnauthorizedError';
import PageNotFound from '../../../../pages/Errors/PageNotFound';
import PageUnauthorized from '../../../../pages/Errors/PageUnauthorized';
import { validateUserAccessToDrupalPath } from '../../../../utils/auth';

export const Route = createFileRoute('/user/reset/$uid/$ts/$hash')({
  loader: async ({ params }) => {
    const { uid, ts, hash } = params;
    const url = `/user/reset/${uid}/${ts}/${hash}`;

    return await validateUserAccessToDrupalPath(url);
  },
  errorComponent: ({ error }) => {
    if (error instanceof UnauthorizedError) {
      return (
        <PageWrapper title="No access" description="You don't have permission to view this page">
          <PageUnauthorized />
        </PageWrapper>
      );
    }

    return (
      <PageWrapper title="Page not found" description="The page is not available or the address does not exist">
        <PageNotFound />
      </PageWrapper>
    );
  },
  component: RouteComponent
});

function RouteComponent() {
  return (
    <PageWrapper title="Reset your password" description="Reset your password">
      <div>Hello "/user/reset/$uid/$ts/$hash"!</div>
    </PageWrapper>
  );
}
